import User from '@/modules/user/model/User';
import KeyValuePair from '@/modules/core/support/KeyValuePair';

export default class RoleUserAssignation {
    public hasRole = false
    public user = new User()

    public get userId () {
        return this.user.id
    }

    public static deserialize (data: KeyValuePair) {
        return Object.assign(new this(), {
            hasRole: data.has_role || false,
            user: User.deserialize(data.user),
        })
    }
}
